import {getProp, CanBeSignal} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, Signal} from '@gongxigames/framework/core/fragments/store/Store';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import type {FixedValSliderProps} from './FixedSlider';

export const DIAMETER = 90;
export const RADIUS = DIAMETER / 2;
export type PointerEventHandler = (event: PointerEvent) => void;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getLayouts(props: FixedValSliderProps, dotPos: Signal<number>, snapVal: Signal<number>) {
    const responsiveFill = Store.computed(() => {
        return {
            updateWidth: true,
            box: {width: `${100 * dotPos.value}%`, y: '50%'},
        } as ResponsiveConf;
    });

    const responsivePoint = Store.computed(() => {
        return {
            box: {x: `${100 * snapVal.value}%`, y: '50%'},
        } as ResponsiveConf;
    });

    const responsiveContainer = Store.computed(() => {
        const responsive = getProp(props.responsive, {} as ResponsiveConf);

        responsive.box ??= {};
        responsive.box.width = getProp(props.size);
        responsive.box.height = `${DIAMETER}px`;

        return responsive;
    });

    return {
        responsiveFill,
        responsivePoint,
        responsiveContainer,
    };
}

export function getSliderTexture(
    disabled: CanBeSignal<boolean | undefined>,
    pressed: Signal<boolean>,
    hover: Signal<boolean>,
): Signal<string> {
    return Store.computed(() => {
        let state = hover.value ? 'focused' : 'normal';

        if (pressed.value) {
            state = 'pressed';
        }

        if (getProp(disabled)) {
            state = 'disabled';
        }

        return `slider_btn_${state}_sys_ui`;
    });
}

export function updateValueOnChange(props: FixedValSliderProps, index: Signal<number>): () => void {
    return Store.effect(() => {
        if (Store.isNotReadonlySignal(props.value)) {
            const arr = getProp(props.values);

            (props.value as Signal).value = arr[index.value];
        }
    });
}